import { map } from 'lodash'

const prepareSpeciality = speciality => {
  return {
    speciality_id: speciality.id
  }
}

export default {
  onShow () {
    this.show = true
  },
  // retornando Especialidades do Profissional selecionado
  getSpecialityProfessional (professionalId) {
    if (professionalId.id) {
      this.$resource.get(professionalId.id + '/active-specialities')
        .then((response) => {
          const optionsProfessionalSpecialitiesArray = Object.keys(response.data).map(i => response.data[i])
          this.optionsProfessionalSpecialities = optionsProfessionalSpecialitiesArray
        })
    }
  },
  prepareShow (staff) {
    return staff
  },
  prepareSave (staff) {
    staff.specialities = map(staff.specialities, prepareSpeciality)

    return staff
  },
  setProfessional (user) {
    this.staff.professional_id = user.id
  },
  toggleModal (value = null) {
    if (value === null) {
      this.showModalPresent = !this.showModalPresent
    } else {
      this.showModalPresent = value
    }
  },
  afterSave (staffs) {
    this.saved = true
  },
  afterCreated () {
    this.wasRaised = true
    this.show = true
  },
  afterUpdated () {
    this.beenUpdated = true
    this.show = true
  },
  onClosePresent () {
    this.showModalPresent = false
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/resources/methods.js